import React from 'react';
import { Grid, Typography, useMediaQuery } from '@mui/material';
import { toCurrency } from '../../../utils/currency/currency.utils';
import { CurrencyCode, CurrencyFormat } from '../../../utils/currency/currency.constants';

interface IProps {
  borderBottom?: string;
  fontSize?: string;
  paddingBottom?: number;
  text: string;
  value: number;
}
export const SummaryRow: React.FC<IProps> = (props) => {
  const { fontSize = '1rem' } = props;
  const isSmall = useMediaQuery('(max-width:600px)');

  return (
    <Grid
      item={true}
      container={true}
      borderBottom={props.borderBottom}
      marginTop={1}
      paddingBottom={props.paddingBottom}
      justifyContent={'space-between'}
    >
      <Grid
        item={true}
        xs={12}
        sm={6}
      >
        <Typography
          marginRight={'auto'}
          fontSize={fontSize}
          color={'white'}
          fontWeight={'bold'}
        >
          {props.text}
        </Typography>
      </Grid>

      <Grid
        item={true}
        xs={12}
        sm={6}
      >
        <Typography
          align={isSmall ? 'left' : 'right'}
          fontSize={fontSize}
          fontWeight={'bold'}
          color={'white'}
        >
          ${toCurrency(props.value, { fractionDigits: 2, currencyCode: CurrencyCode.USD, format: CurrencyFormat.None })}
        </Typography>
      </Grid>
    </Grid>
  );
};

SummaryRow.displayName = 'SummaryRow';
